import { useEffect, useState } from "react";

import {
  logUserAssignedToVariant,
  useFeatureFlag
} from "features/feature-flags";

export const EXTENDED_REWARDS_RELEASE_ID = "show-extended-rewards";

export function useShowExtendedRewardsFeatureFlag(): boolean {
  const flag = !!useFeatureFlag(EXTENDED_REWARDS_RELEASE_ID);

  const [loggedAnalytics, setLoggedAnalytics] = useState(false);

  useEffect(() => {
    if (loggedAnalytics) return;

    logUserAssignedToVariant({
      testId: EXTENDED_REWARDS_RELEASE_ID,
      variant: flag
    });

    setLoggedAnalytics(true);
  }, [flag, loggedAnalytics]);

  return flag;
}
